<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择"
    style="width: 100%"
    filterable
  >
    <el-option key="0" label="所有" :value="0" v-if="filter"></el-option>
    <el-option key="00" label="无" :value="0" v-else disabled></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { dealerStageDiscountList } from '@/service/getData'

export default {
  props: {
    value: '',
    filter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await dealerStageDiscountList()
      if (res.code == 0) {
        this.lists = res.data.list
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>